exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ms-ContextualMenu-icon ._34U-dwA4A9qL_t4zAEdQ73{position:relative;top:-8px}", ""]);

// exports
exports.locals = {
	"fallbackIcon": "_34U-dwA4A9qL_t4zAEdQ73"
};